/**
 * Wood material prices per m³ in USD.
 *
 * Prices are for kiln-dried, planed lumber suitable for staircase production.
 * Update this file when market prices change.
 *
 * Last updated: 2026-04
 */

export interface IWoodPrices {
    readonly pine: number;
    readonly birch: number;
    readonly larch: number;
    readonly beech: number;
    readonly oak: number;
    readonly ash: number;
}

export const WOOD_PRICES_USD: IWoodPrices = {
    pine: 700,
    birch: 950,
    larch: 1200,
    beech: 1500,
    oak: 1900,
    ash: 1600,
};
